export const iconFontAwesomeMedicalHealthHeartCircleXmark = (
	<i className="fa-solid fa-heart-circle-xmark"></i>
);
